import { useCallback } from 'react';
import { useReadContracts } from 'wagmi';
import { stakingManagerAbi } from '@syntra/abi';
import { DEPLOYMENT as D } from '../config/env.ts';

/**
 * How far the staking contract's payouts lag the clock: `behind` finished epochs nobody has processed yet. The
 * keeper normally keeps it at 0 or 1; beyond 30 the contract refuses new stakes until someone catches up.
 */
export function useEpochStatus() {
  const q = useReadContracts({
    allowFailure: false,
    contracts: [
      { address: D.staking, abi: stakingManagerAbi, functionName: 'lastProcessedEpoch' },
      { address: D.staking, abi: stakingManagerAbi, functionName: 'currentEpoch' },
    ],
    query: { refetchInterval: 15_000 },
  });
  const gap = (d: readonly [bigint, bigint] | undefined) => (d && d[1] > d[0] ? Number(d[1] - d[0]) : 0);
  const refetchQuery = q.refetch;
  /** Re-reads the chain and returns the epochs still behind. */
  const refetch = useCallback(async () => gap((await refetchQuery()).data as readonly [bigint, bigint] | undefined), [refetchQuery]);
  return { behind: gap(q.data as readonly [bigint, bigint] | undefined), refetch };
}
